import React from 'react';

import { TickerCard } from '../../library/ticker-card/TickerCard';


export const ConversionTicker = ({ value }) =>
  <TickerCard
    title='Conversion'
    icon='datausage'
    tone='warning'
    value={value}
    formatValue={(value) => `${value}%`}
    percentage={-2.3}
  />;
